import { TranslationService } from "@sdbn/common";
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from "@angular/forms";
import { Component, OnInit } from "@angular/core";
import {
  CameraDefinition,
  RFIDDefinition,
  RFIDReader,
} from "../../yard-simulator.model";
import { HttpService, ServiceResponse } from "@sdbn/appclient";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-rfid-reader",
  templateUrl: "./rfid-reader.component.html",
  styleUrls: ["./rfid-reader.component.scss"],
})
export class RfidReaderComponent implements OnInit {
  rfidSelected: RFIDDefinition;
  rfids: RFIDDefinition[];

  scannedNumber: string;

  formGroup = new FormGroup({});

  constructor(
    public translationService: TranslationService,
    private service: HttpService
  ) {
    this.formGroup.addControl("scannedNumber", new FormControl("", []));
    this.formGroup.addControl("rfidSelection", new FormControl("", []));
    this.formGroup.valueChanges.subscribe((formValues) => {
      this.scannedNumber = formValues.scannedNumber;
    });
  }

  ngOnInit() {
    this.service
      .postWithContext<CameraDefinition[]>(
        environment.yardSimulatorAdminEntpoint + "/rfid-readers",
        {}
      )
      .subscribe((rfids) => {
        this.rfids = rfids;
      });
  }

  onCameraSelection(rfid: RFIDDefinition) {
    this.rfidSelected = rfid;
  }

  onButtonTrigger() {
    const rfidReader = new RFIDReader({
      identifier: this.rfidSelected.identifier,
      scannedNumber: this.scannedNumber,
    });

    this.service
      .postWithContext<ServiceResponse>(
        environment.yardSimulatorAdminEntpoint + "/rfid",
        rfidReader
      )
      .subscribe((response) => {
        console.log(response.status, ":\n", response.responseMessages);
      });
  }
}
